import React from 'react'
import styles from './UIGamePlayerInfoToggleContentPieces.module.scss'
import {CITY_IMAGE_PATH} from '../UIGameActionButtonsContainer/UIGameActionButtonCity/utils'
import {ROAD_IMAGE_PATH} from '../UIGameActionButtonsContainer/UIGameActionButtonRoad/utils'
import {SETTLEMENT_IMAGE_PATH} from '../UIGameActionButtonsContainer/UIGameActionButtonSettlement/utils'
import {PlayerColorWithoutNone} from '../../utils/gameColors'

export interface UIGamePlayerInfoToggleContentPiecesProps {
    playerColor: PlayerColorWithoutNone
}

export const UIGamePlayerInfoToggleContentPieces = ({
    playerColor,
}: UIGamePlayerInfoToggleContentPiecesProps) => {
    const roadIcon = ROAD_IMAGE_PATH[playerColor]
    const settlementIcon = SETTLEMENT_IMAGE_PATH[playerColor]
    const cityIcon = CITY_IMAGE_PATH[playerColor]

    return (
        <div className={styles.container}>
            <div className={styles.pieces}>
                <img src={roadIcon} />
                <img src={settlementIcon} />
                <img src={cityIcon} />
            </div>
        </div>
    )
}
